import { IStringLocalizer } from "../../utilities/IStringLocalizer";

export interface TemplateFilenameAndDescription {
    filename: string;
    localizedDescription: string;
}

// ===============================================================================

/**
* Manager to handle the bom template types and names.
*/
export class BomTemplatesManager {

    // ===============================================================================

    /**
    * Returns the 2 standard Bom templates.
    * 
    * @param localizer localizer for the template description.
    */
    public static getStandardBomImportTemplate(localizer: IStringLocalizer) {
        return [
            { filename: encodeURIComponent("Simple Product BOM template.xlsx"), localizedDescription: localizer.localizeString("Simple BOM Template") },
            { filename: encodeURIComponent("All Fields Template.xlsx"), localizedDescription: localizer.localizeString("Advanced BOM Template (All Fields)") }
        ];
    }

    // ===============================================================================

    /**
    * Given a report type, this method returns a list of objects that define an import
    * template for download.
    *
    * @param reportType the report type to get the template info for.
    * @param localizer localizer for the template description.
    */
    public static getImportTemplatesForReportType(reportType: string, localizer: IStringLocalizer): TemplateFilenameAndDescription[] {
        switch (reportType) {
            case "declare":
            case "declare-materials":
                return [{ filename: encodeURIComponent("Declare Label Template.xlsx"), localizedDescription: localizer.localizeString("Declare Label Template") }];
            case "hpd":
            case "hpd-simple":
            case "hpd-material-threshold":
                return [{ filename: encodeURIComponent("HPD Template.xlsx"), localizedDescription: localizer.localizeString("HPD Template") }];
            case "c2c-report":
                return [{ filename: encodeURIComponent("MBDC Template.xlsx"), localizedDescription: localizer.localizeString("MBDC Submission for Cradle to Cradle Template") }];
            default:
                return BomTemplatesManager.getStandardBomImportTemplate(localizer);
        }
    }
}